var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-btn font-16 font500 flex flex-col-center",class:['i-btn-'+_vm.btnType,_vm.cusClass],style:([_vm.customStyle]),on:{"click":_vm.handleClick}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }